// src/components/Shared/ScrollToTop.jsx
// FRONT OFFICE - Utility component to scroll to top when changing routes

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;